import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const ProjectList = ({
  optionList,
  onChangeHandle,
  value,
  hasError = false,
  errorMessage = "",
  isRquired = true,
  customTitle = <></>,
  titleview = true,
  selectClass = "slds-select",
  searchable = false,
  customPlaceHolder = null,
  customSelectStyles,
}) => {
  const [selectValue, setSelectValue] = useState("");
  const { t } = useTranslation(["util"]);
  useEffect(() => {
    setSelectValue("null");
    console.log("updated");
  }, [optionList]);

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "38px",
      borderColor: hasError ? "#ea001e" : base.borderColor,
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <div
      className={`slds-form-element ${hasError ? "slds-has-error" : ""} select-remove-icon mb-2`}
    >
      {titleview && (
        <label className="slds-form-element__label ">
          {t("plantProject")}{" "}
          {isRquired ? (
            <abbr className="slds-required" title="required">
              *{" "}
            </abbr>
          ) : null}
        </label>
      )}
      {customTitle}

      <div className="slds-form-element__control">
        <div className="slds-select_container">
          {searchable ? (
            <Select
              classNamePrefix="clide-searchable-select"
              options={optionList.map((item) => ({
                value: item.project_id,
                label: item.project,
              }))}
              value={
                value == null || value === ""
                  ? null
                  : (() => {
                      const found = optionList.find(
                        (item) => String(item.project_id) === String(value),
                      );
                      return found
                        ? { value: found.project_id, label: found.project }
                        : null;
                    })()
              }
              onChange={(selectedOption) =>
                onChangeHandle(selectedOption ? selectedOption.value : "")
              }
              placeholder={`${t("select")} ${!customPlaceHolder ? t("plantProject") : customPlaceHolder}`}
              noOptionsMessage={() => t("noProjectAvailable")}
              isClearable
              //menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              menuPlacement="auto"
              menuPosition="absolute"
              //menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              styles={customSelectStyles}
            />
          ) : (
            <select
              className={selectClass}
              onChange={(event) => onChangeHandle(event.target.value)}
              value={value}
            >
              {optionList.length ? (
                <>
                  <option value="">
                    {t("select")} {t("plantProject")}
                  </option>
                  {optionList.map((item, index) => (
                    <option
                      key={`project-option-${index}`}
                      value={item.project_id}
                      showcontractor={item.contractor_flag}
                    >
                      {item.project}
                    </option>
                  ))}
                </>
              ) : (
                <option value={null} selected>
                  {t("noProjectAvailable")}
                </option>
              )}
            </select>
          )}
        </div>
      </div>
      {hasError ? (
        <div class="slds-form-element__help" id="error-01">
          {errorMessage !== "" ? errorMessage : t("noProjectAvailable")}
        </div>
      ) : null}
    </div>
  );
};

ProjectList.defaultProps = {
  optionList: [],
  onChangeHandle: () => {},
  value: "",
  searchable: false,
};

export default ProjectList;
